// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/auth-bg.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bruno+Ace+SC&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Albert+Sans:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* You can add global styles to this file, and also import other style files */
/*------ font family variable --------
==================================================*/
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
*::-webkit-scrollbar {
  scrollbar-width: none;
  display: none;
  height: 0px;
  width: 0px;
}

body {
  font-family: "Inter", serif;
}

ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

button:focus-visible {
  outline: none !important;
}

.desktop-order-track.order-confirmed li:first-child .rounded {
  background-color: #00FF7F !important;
}
.desktop-order-track.shipped li:first-child::before {
  background-color: #00FF7F !important;
}
.desktop-order-track.shipped li:first-child .rounded {
  background-color: #00FF7F !important;
}
.desktop-order-track.shipped li:nth-child(2)::after {
  background-color: #00FF7F !important;
}
.desktop-order-track.shipped li:nth-child(2) .rounded {
  background-color: #00FF7F !important;
}
.desktop-order-track.out-of-delivery li:first-child::before {
  background-color: #00FF7F !important;
}
.desktop-order-track.out-of-delivery li:first-child .rounded {
  background-color: #00FF7F !important;
}
.desktop-order-track.out-of-delivery li:nth-child(2)::after, .desktop-order-track.out-of-delivery li:nth-child(2)::before {
  background-color: #00FF7F !important;
}
.desktop-order-track.out-of-delivery li:nth-child(2) .rounded {
  background-color: #00FF7F !important;
}
.desktop-order-track.out-of-delivery li:nth-child(3)::after {
  background-color: #00FF7F !important;
}
.desktop-order-track.out-of-delivery li:nth-child(3) .rounded {
  background-color: #00FF7F !important;
}
.desktop-order-track.delivery li::after, .desktop-order-track.delivery li::before {
  background-color: #00FF7F !important;
}
.desktop-order-track.delivery li .rounded {
  background-color: #00FF7F !important;
}
.desktop-order-track .order-track {
  z-index: 1;
}
.desktop-order-track .order-track:last-child::before {
  display: none;
}
.desktop-order-track .order-track:first-child::after {
  display: none;
}
.desktop-order-track .order-track::before {
  position: absolute;
  content: "";
  width: 50%;
  height: 0.25rem;
  right: 0;
  top: 46%;
  background-color: #e9e9e9;
  z-index: -1;
}
.desktop-order-track .order-track::after {
  position: absolute;
  content: "";
  width: 50%;
  height: 0.25rem;
  left: 0;
  top: 46%;
  background-color: #e9e9e9;
  z-index: -1;
}
.desktop-order-track .order-track .rounded {
  background-color: #e9e9e9;
}

.mob-order-track-wrapper .mob-order-track {
  z-index: 1;
}
.mob-order-track-wrapper .mob-order-track:last-child::before {
  display: none;
}
.mob-order-track-wrapper .mob-order-track::before {
  position: absolute;
  content: "";
  height: 100%;
  width: 0.25rem;
  left: 0.7rem;
  top: 0;
  background-color: #e9e9e9;
  z-index: -1;
}
.mob-order-track-wrapper .mob-order-track .rounded {
  background-color: #e9e9e9;
}
.mob-order-track-wrapper.order-confirmed li:first-child .rounded {
  background-color: #00FF7F !important;
}
.mob-order-track-wrapper.shipped li:first-child .rounded {
  background-color: #00FF7F !important;
}
.mob-order-track-wrapper.shipped li:first-child::before {
  background-color: #00FF7F !important;
}
.mob-order-track-wrapper.shipped li:nth-child(2) .rounded {
  background-color: #00FF7F !important;
}
.mob-order-track-wrapper.out-of-delivery li:first-child .rounded {
  background-color: #00FF7F !important;
}
.mob-order-track-wrapper.out-of-delivery li:first-child::before {
  background-color: #00FF7F !important;
}
.mob-order-track-wrapper.out-of-delivery li:nth-child(2)::before {
  background-color: #00FF7F !important;
}
.mob-order-track-wrapper.out-of-delivery li:nth-child(2) .rounded {
  background-color: #00FF7F !important;
}
.mob-order-track-wrapper.out-of-delivery li:nth-child(3) .rounded {
  background-color: #00FF7F !important;
}
.mob-order-track-wrapper.delivery li .rounded {
  background-color: #00FF7F !important;
}
.mob-order-track-wrapper.delivery li::before {
  background-color: #00FF7F !important;
}

.nft-track-container.pending .nft-track-wrapper:first-child .first-round {
  background: rgba(0, 0, 0, 0.4) !important;
}
.nft-track-container.pending .nft-track-wrapper:first-child .first-round::before {
  background-color: #000000 !important;
}
.nft-track-container.pending .nft-track-wrapper:first-child .first-round .inner-round {
  background-color: #00FF7F !important;
}
.nft-track-container.shipped .nft-track-wrapper:first-child .first-round::before {
  background-color: #000000 !important;
}
.nft-track-container.shipped .nft-track-wrapper:first-child .first-round .inner-round {
  background-color: #00FF7F !important;
}
.nft-track-container.shipped .nft-track-wrapper:nth-child(2) .first-round {
  background: rgba(0, 0, 0, 0.4) !important;
}
.nft-track-container.shipped .nft-track-wrapper:nth-child(2) .first-round::before {
  background-color: #000000 !important;
}
.nft-track-container.shipped .nft-track-wrapper:nth-child(2) .first-round .inner-round {
  background-color: #00FF7F !important;
}
.nft-track-container.out_for_delivery .nft-track-wrapper:first-child .first-round::before {
  background-color: #000000 !important;
}
.nft-track-container.out_for_delivery .nft-track-wrapper:first-child .first-round .inner-round {
  background-color: #00FF7F !important;
}
.nft-track-container.out_for_delivery .nft-track-wrapper:nth-child(2) .first-round::before {
  background-color: #000000 !important;
}
.nft-track-container.out_for_delivery .nft-track-wrapper:nth-child(2) .first-round .inner-round {
  background-color: #00FF7F !important;
}
.nft-track-container.out_for_delivery .nft-track-wrapper:nth-child(3) .first-round {
  background: rgba(0, 0, 0, 0.4) !important;
}
.nft-track-container.out_for_delivery .nft-track-wrapper:nth-child(3) .first-round::before {
  background-color: #000000 !important;
}
.nft-track-container.out_for_delivery .nft-track-wrapper:nth-child(3) .first-round .inner-round {
  background-color: #00FF7F !important;
}
.nft-track-container.delivered .nft-track-wrapper .first-round::before {
  background-color: #000000 !important;
}
.nft-track-container.delivered .nft-track-wrapper .first-round .inner-round {
  background-color: #00FF7F !important;
}
.nft-track-container.delivered .nft-track-wrapper:last-child .first-round {
  background: rgba(0, 0, 0, 0.4) !important;
}

.nft-track-wrapper {
  position: relative;
  z-index: 1;
  padding-bottom: 1.5rem;
}
.nft-track-wrapper:first-child::after {
  position: absolute;
  content: "";
  height: 2.25rem;
  width: 0.094rem;
  left: 0.95rem;
  top: -2rem;
  border-left: 0.094rem dashed rgba(0, 0, 0, 0.4);
  z-index: -1;
}
.nft-track-wrapper:last-child {
  padding-bottom: 0;
}
.nft-track-wrapper:last-child::before {
  display: none;
}
.nft-track-wrapper::before {
  position: absolute;
  content: "";
  height: calc(100% - 1.5rem);
  width: 0.094rem;
  left: 0.95rem;
  top: 1.75rem;
  border-left: 0.094rem dashed rgba(0, 0, 0, 0.4);
  z-index: -1;
}
.nft-track-wrapper .first-round {
  width: 2rem;
  height: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;
}
.nft-track-wrapper .first-round::before {
  position: absolute;
  content: "";
  inset: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
}
.nft-track-wrapper .first-round .inner-round {
  width: 0.5rem;
  height: 0.5rem;
  background-color: #00FF7F 80;
  border-radius: 50%;
  position: relative;
  z-index: 2;
}

.title-stroke {
  background: #000000;
  -webkit-background-clip: text;
  -webkit-text-stroke-color: transparent;
  -webkit-text-stroke-width: 0.125rem;
  color: #00FF7F;
  font-weight: 800;
  letter-spacing: 0.063rem;
}

.react-tel-input .form-control {
  width: 100% !important;
  height: 2.75rem;
  border-radius: 0.75rem;
  border-width: var(--heroui-border-width-medium);
  --tw-border-opacity: 1;
  border-color: rgb(194 194 194 / var(--tw-border-opacity, 1));
}

.react-tel-input .form-control:hover{
  --tw-border-opacity: 1;
  border-color: rgb(194 194 194 / var(--tw-border-opacity, 1));
}

.react-tel-input .form-control:focus{
  --tw-border-opacity: 1;
  border-color: rgb(194 194 194 / var(--tw-border-opacity, 1));
  box-shadow: none !important;
  border-color: #c2c2c2 !important;
}

.auth-section-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.width-5 {
  width: 5% !important;
}

.width-10 {
  width: 10% !important;
}

.width-15 {
  width: 15% !important;
}

.width-20 {
  width: 20% !important;
}

.width-25 {
  width: 25% !important;
}

.width-30 {
  width: 30% !important;
}

.width-35 {
  width: 35% !important;
}

.width-40 {
  width: 40% !important;
}

.width-45 {
  width: 45% !important;
}

.width-50 {
  width: 50% !important;
}

.width-55 {
  width: 55% !important;
}

.width-60 {
  width: 60% !important;
}

.width-65 {
  width: 65% !important;
}

.width-70 {
  width: 70% !important;
}

.width-75 {
  width: 75% !important;
}

.width-80 {
  width: 80% !important;
}

.width-85 {
  width: 85% !important;
}

.width-90 {
  width: 90% !important;
}

.width-95 {
  width: 95% !important;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-none {
  cursor: none;
}

.hero-section {
  padding-top: 4rem;
  background-color: #000;
}
@media screen and (max-width: 768px) {
  .hero-section {
    padding-top: 3rem;
  }
}
@media screen and (max-width: 568px) {
  .hero-section {
    padding-top: 2rem;
  }
}
.hero-section .hero-container {
  display: flex;
}
@media screen and (max-width: 991px) {
  .hero-section .hero-container {
    flex-direction: column;
  }
}
.hero-section .hero-container .left-sdie-wrapper {
  width: 60%;
  padding: 0 5.5rem 0 4.25rem;
}
@media screen and (max-width: 991px) {
  .hero-section .hero-container .left-sdie-wrapper {
    width: 100%;
    padding: 1rem;
  }
}
.hero-section .hero-container .left-sdie-wrapper .content h1 {
  margin: 0;
  font-weight: 700;
  font-size: 4.063rem;
  line-height: 1.3;
  text-transform: uppercase;
  color: #fff;
}
.hero-section .hero-container .left-sdie-wrapper .content h1 span {
  letter-spacing: 0.203rem;
}
@media screen and (max-width: 1400px) {
  .hero-section .hero-container .left-sdie-wrapper .content h1 {
    font-size: 3.5rem;
  }
}
@media screen and (max-width: 1300px) {
  .hero-section .hero-container .left-sdie-wrapper .content h1 {
    font-size: 3rem;
  }
}
@media screen and (max-width: 1150px) {
  .hero-section .hero-container .left-sdie-wrapper .content h1 {
    font-size: 2.75rem;
  }
}
@media screen and (max-width: 1100px) {
  .hero-section .hero-container .left-sdie-wrapper .content h1 {
    font-size: 2rem;
  }
}
@media screen and (max-width: 991px) {
  .hero-section .hero-container .left-sdie-wrapper .content h1 {
    font-size: 4rem;
  }
}
@media screen and (max-width: 768px) {
  .hero-section .hero-container .left-sdie-wrapper .content h1 {
    font-size: 3.5rem;
  }
}
@media screen and (max-width: 600px) {
  .hero-section .hero-container .left-sdie-wrapper .content h1 {
    font-size: 3rem;
  }
  .hero-section .hero-container .left-sdie-wrapper .content h1 span {
    letter-spacing: 0.125rem;
  }
}
@media screen and (max-width: 567px) {
  .hero-section .hero-container .left-sdie-wrapper .content h1 {
    font-size: 2.75rem;
  }
}
@media screen and (max-width: 480px) {
  .hero-section .hero-container .left-sdie-wrapper .content h1 {
    font-size: 2rem;
  }
}
@media screen and (max-width: 360px) {
  .hero-section .hero-container .left-sdie-wrapper .content h1 {
    font-size: 1.5rem;
  }
}
.hero-section .hero-container .left-sdie-wrapper .content h6 {
  margin: 0;
  font-weight: 700;
  font-size: 7.5rem;
  line-height: 1.2;
  color: #00ff7f;
}
@media screen and (max-width: 1300px) {
  .hero-section .hero-container .left-sdie-wrapper .content h6 {
    font-size: 6rem;
  }
}
@media screen and (max-width: 1200px) {
  .hero-section .hero-container .left-sdie-wrapper .content h6 {
    font-size: 5rem;
  }
}
@media screen and (max-width: 360px) {
  .hero-section .hero-container .left-sdie-wrapper .content h6 {
    font-size: 4rem;
  }
}
.hero-section .hero-container .left-sdie-wrapper .content p {
  margin: 0;
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 1.6;
  color: #fff;
  max-width: 27rem;
}
@media screen and (max-width: 1100px) {
  .hero-section .hero-container .left-sdie-wrapper .content p {
    max-width: 25rem;
  }
}
@media screen and (max-width: 991px) {
  .hero-section .hero-container .left-sdie-wrapper .content p {
    max-width: unset;
  }
}
@media screen and (max-width: 567px) {
  .hero-section .hero-container .left-sdie-wrapper .content p {
    font-size: 1rem;
  }
}
.hero-section .hero-container .right-sdie-wrapper {
  position: relative;
  width: 40%;
  background: #00ff7f;
  z-index: 1;
}
@media screen and (max-width: 991px) {
  .hero-section .hero-container .right-sdie-wrapper {
    width: 100%;
    padding: 2rem 1rem;
  }
}
.hero-section .hero-container .right-sdie-wrapper::after {
  position: absolute;
  content: "";
  right: 0;
  bottom: 0;
  clip-path: polygon(100% 30%, 0% 100%, 100% 100%);
  width: 10rem;
  height: 10rem;
  background-color: #000;
  z-index: -1;
}
@media screen and (max-width: 991px) {
  .hero-section .hero-container .right-sdie-wrapper::after {
    display: none;
  }
}
.hero-section .hero-container .right-sdie-wrapper img {
  position: relative;
  top: -3rem;
  left: -6rem;
}
@media screen and (max-width: 1500px) {
  .hero-section .hero-container .right-sdie-wrapper img {
    left: -4rem;
  }
}
@media screen and (max-width: 1400px) {
  .hero-section .hero-container .right-sdie-wrapper img {
    left: -3.5rem;
  }
}
@media screen and (max-width: 991px) {
  .hero-section .hero-container .right-sdie-wrapper img {
    position: unset;
    top: 0;
    left: 0;
  }
}
.hero-section .hero-container .right-sdie-wrapper button {
  position: absolute;
  right: 21%;
  bottom: -1rem;
}
@media screen and (min-width: 360px) {
  .hero-section .hero-container .right-sdie-wrapper button {
    right: 27%;
    bottom: -1rem;
  }
}
@media screen and (min-width: 992px) {
  .hero-section .hero-container .right-sdie-wrapper button {
    right: 38%;
    bottom: 2rem;
  }
}

.shoe-banner-section {
  overflow: hidden;
}
.shoe-banner-section .shoe-banner {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 1300px) {
  .shoe-banner-section .shoe-banner {
    min-height: 25rem;
  }
}
@media screen and (max-width: 992px) {
  .shoe-banner-section .shoe-banner {
    min-height: 20rem;
  }
}
@media screen and (max-width: 768px) {
  .shoe-banner-section .shoe-banner {
    min-height: 15rem;
  }
}
@media screen and (max-width: 568px) {
  .shoe-banner-section .shoe-banner {
    min-height: 8rem;
  }
}
.shoe-banner-section .shoe-banner .shoe-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transform: scale(1.8);
}`, "",{"version":3,"sources":["webpack://./src/styles/styles.scss","webpack://./src/styles/abstracts/_variables.scss","webpack://./src/styles/abstracts/_common.scss","webpack://./src/styles/abstracts/_helpers.scss","webpack://./src/styles/abstracts/_mixins.scss","webpack://./src/styles/partial/_hero-section.scss","webpack://./src/styles/partial/_shoe-banner.scss"],"names":[],"mappings":"AAAA,8EAAA;ACgCA;mDAAA;AChCA;EACE,UAAA;EACA,SAAA;EACA,sBAAA;AFSF;AERE;EACE,qBAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;AFUJ;;AENA;EACE,2BDsBY;ADbd;;AENA;EACE,UAAA;EACA,SAAA;EACA,gBAAA;AFSF;;AELE;EACE,wBAAA;AFQJ;;AEAQ;EACE,oCAAA;AFGV;AEMQ;EACE,oCAAA;AFJV;AEMQ;EACE,oCAAA;AFJV;AEQQ;EACE,oCAAA;AFNV;AEQQ;EACE,oCAAA;AFNV;AEeQ;EACE,oCAAA;AFbV;AEeQ;EACE,oCAAA;AFbV;AEiBQ;EAEE,oCAAA;AFhBV;AEkBQ;EACE,oCAAA;AFhBV;AEoBQ;EACE,oCAAA;AFlBV;AEoBQ;EACE,oCAAA;AFlBV;AE0BM;EAEE,oCAAA;AFzBR;AE2BM;EACE,oCAAA;AFzBR;AE6BE;EACE,UAAA;AF3BJ;AE6BM;EACE,aAAA;AF3BR;AE+BM;EACE,aAAA;AF7BR;AEgCI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,QAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;AF9BN;AEgCI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;AF9BN;AEgCI;EACE,yBAAA;AF9BN;;AEoCE;EACE,UAAA;AFjCJ;AEmCM;EACE,aAAA;AFjCR;AEoCI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,MAAA;EACA,yBAAA;EACA,WAAA;AFlCN;AEoCI;EACE,yBAAA;AFlCN;AEwCQ;EACE,oCAAA;AFtCV;AE8CQ;EACE,oCAAA;AF5CV;AE8CQ;EACE,oCAAA;AF5CV;AEgDQ;EACE,oCAAA;AF9CV;AEsDQ;EACE,oCAAA;AFpDV;AEsDQ;EACE,oCAAA;AFpDV;AEwDQ;EACE,oCAAA;AFtDV;AEwDQ;EACE,oCAAA;AFtDV;AE0DQ;EACE,oCAAA;AFxDV;AE+DM;EACE,oCAAA;AF7DR;AE+DM;EACE,oCAAA;AF7DR;;AEuEQ;EACE,yCAAA;AFpEV;AEqEU;EACE,oCAAA;AFnEZ;AEqEU;EACE,oCAAA;AFnEZ;AE6EU;EACE,oCAAA;AF3EZ;AE6EU;EACE,oCAAA;AF3EZ;AEgFQ;EACE,yCAAA;AF9EV;AE+EU;EACE,oCAAA;AF7EZ;AE+EU;EACE,oCAAA;AF7EZ;AEuFU;EACE,oCAAA;AFrFZ;AEuFU;EACE,oCAAA;AFrFZ;AE2FU;EACE,oCAAA;AFzFZ;AE2FU;EACE,oCAAA;AFzFZ;AE8FQ;EACE,yCAAA;AF5FV;AE6FU;EACE,oCAAA;AF3FZ;AE6FU;EACE,oCAAA;AF3FZ;AEoGQ;EACE,oCAAA;AFlGV;AEoGQ;EACE,oCAAA;AFlGV;AEsGQ;EACE,yCAAA;AFpGV;;AE0GA;EACE,kBAAA;EACA,UAAA;EACA,sBAAA;AFvGF;AE0GI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,+CAAA;EACA,WAAA;AFxGN;AE2GE;EACE,iBAAA;AFzGJ;AE0GI;EACE,aAAA;AFxGN;AE2GE;EACE,kBAAA;EACA,WAAA;EACA,2BAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,+CAAA;EACA,WAAA;AFzGJ;AE4GE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AF1GJ;AE2GI;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;AFzGN;AE2GI;EACE,aAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AFzGN;;AE8GA;EACE,mBAAA;EACA,6BAAA;EACA,sCAAA;EACA,mCAAA;EACA,cAAA;EACA,gBAAA;EACA,wBAAA;AF3GF;;AE8GA;EACE,sBAAA;EACA,eAAA;EAAA,sBAAA;EAAA,+CAAA;EAAA,sBAAA;EAAA,4DAAA;AF3GF;;AE2GE;EAAA,sBAAA;EAAA;AAAA;;AAAA;EAAA,sBAAA;EAAA,4DAAA;EAEE,2BAAA;EACA;AAHF;;AAOF;EACE,mDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;AF3GF;;AGxRE;EACE,oBAAA;AH2RJ;;AG5RE;EACE,qBAAA;AH+RJ;;AGhSE;EACE,qBAAA;AHmSJ;;AGpSE;EACE,qBAAA;AHuSJ;;AGxSE;EACE,qBAAA;AH2SJ;;AG5SE;EACE,qBAAA;AH+SJ;;AGhTE;EACE,qBAAA;AHmTJ;;AGpTE;EACE,qBAAA;AHuTJ;;AGxTE;EACE,qBAAA;AH2TJ;;AG5TE;EACE,qBAAA;AH+TJ;;AGhUE;EACE,qBAAA;AHmUJ;;AGpUE;EACE,qBAAA;AHuUJ;;AGxUE;EACE,qBAAA;AH2UJ;;AG5UE;EACE,qBAAA;AH+UJ;;AGhVE;EACE,qBAAA;AHmVJ;;AGpVE;EACE,qBAAA;AHuVJ;;AGxVE;EACE,qBAAA;AH2VJ;;AG5VE;EACE,qBAAA;AH+VJ;;AGhWE;EACE,qBAAA;AHmWJ;;AIhOE;EACE,eD7HM;AHgWV;;AIpOE;EACE,YD7HM;AHoWV;;AK7XA;EACE,iBAAA;EACA,sBAAA;ALgYF;AK/XE;EAHF;IAII,iBAAA;ELkYF;AACF;AKjYE;EANF;IAOI,iBAAA;ELoYF;AACF;AKnYE;EACE,aAAA;ALqYJ;AKpYI;EAFF;IAGI,sBAAA;ELuYJ;AACF;AKtYI;EACE,UAAA;EACA,2BAAA;ALwYN;AKvYM;EAHF;IAII,WAAA;IACA,aAAA;EL0YN;AACF;AKxYQ;EACE,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;AL0YV;AKzYU;EACE,wBAAA;AL2YZ;AKzYU;EAVF;IAWI,iBAAA;EL4YV;AACF;AK3YU;EAbF;IAiBI,eAAA;EL2YV;AACF;AK1YU;EAnBF;IAoBI,kBAAA;ELkZV;AACF;AKjZU;EAtBF;IAuBI,eAAA;ELoZV;AACF;AKnZU;EAzBF;IA0BI,eAAA;ELsZV;AACF;AKrZU;EA5BF;IA6BI,iBAAA;ELwZV;AACF;AKvZU;EA/BF;IAgCI,eAAA;EL0ZV;EKzZU;IACE,wBAAA;EL2ZZ;AACF;AKzZU;EArCF;IAsCI,kBAAA;EL4ZV;AACF;AK3ZU;EAxCF;IAyCI,eAAA;EL8ZV;AACF;AK7ZU;EA3CF;IA4CI,iBAAA;ELgaV;AACF;AK9ZQ;EACE,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;ALgaV;AK/ZU;EANF;IAOI,eAAA;ELkaV;AACF;AKjaU;EATF;IAUI,eAAA;ELoaV;AACF;AKnaU;EAZF;IAaI,eAAA;ELsaV;AACF;AKpaQ;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;ALsaV;AKraU;EAPF;IAQI,gBAAA;ELwaV;AACF;AKvaU;EAVF;IAWI,gBAAA;EL0aV;AACF;AKzaU;EAbF;IAcI,eAAA;EL4aV;AACF;AKxaI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;AL0aN;AKzaM;EALF;IAMI,WAAA;IACA,kBAAA;EL4aN;AACF;AK3aM;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,gDAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AL6aR;AK5aQ;EAVF;IAWI,aAAA;EL+aR;AACF;AK5aM;EACE,kBAAA;EACA,UAAA;EACA,WAAA;AL8aR;AK7aQ;EAJF;IAKI,WAAA;ELgbR;AACF;AK/aQ;EAPF;IAQI,aAAA;ELkbR;AACF;AKjbQ;EAVF;IAWI,eAAA;IACA,MAAA;IACA,OAAA;ELobR;AACF;AKlbM;EACE,kBAAA;EACA,UAAA;EACA,aAAA;ALobR;AKnbQ;EAJF;IAKI,UAAA;IACA,aAAA;ELsbR;AACF;AKrbQ;EARF;IASI,UAAA;IACA,YAAA;ELwbR;AACF;;AMnlBA;EACE,gBAAA;ANslBF;AMplBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ANslBJ;AMrlBI;EAJF;IAKI,iBAAA;ENwlBJ;AACF;AMvlBI;EAPF;IAQI,iBAAA;EN0lBJ;AACF;AMzlBI;EAVF;IAWI,iBAAA;EN4lBJ;AACF;AM3lBI;EAbF;IAcI,gBAAA;EN8lBJ;AACF;AM7lBI;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;AN+lBN","sourcesContent":["/* You can add global styles to this file, and also import other style files */\n\n@import \"./abstracts/_abstracts-dir\";\n@import \"./partial/_partial-dir\";\n\n@import \"./reset\";\n@import \"./typography\";\n\n","// ==== Standard Bootstrap Breakpoints ====\r\n\r\n$screen-sm: 576px;\r\n$screen-md: 767px;\r\n$screen-lg: 992px;\r\n$screen-xl: 1200px;\r\n$screen-xxl: 1400px;\r\n\r\n// ==== Custom Breakpoints ====\r\n\r\n$screen-alt-363: 363px;\r\n$screen-alt-480: 480px;\r\n$screen-alt-768: 768px;\r\n$screen-alt-1024: 1024px;\r\n$screen-alt-1350: 1350px;\r\n$screen-alt-1500: 1500px;\r\n$screen-alt-1600: 1600px;\r\n\r\n// 2560 x 1600\r\n// 1920 × 1080 (8.89%)\r\n// 1536 × 864 (3.88%)\r\n// 1366 × 768 (8.44%)\r\n// 1024 x 768\r\n\r\n// 480 width\r\n// 375 width\r\n\r\n// no use\r\n// 414×896 (4.58%)\r\n// 375×667 (3.75%)\r\n// 360×640 (7.28%)\r\n\r\n/*------ font family variable --------\r\n==================================================*/\r\n\r\n$font-family: \"Inter\", serif;\r\n\r\n:root {\r\n  // ==== light theme text colors ====\r\n\r\n}\r\n\r\n.dark {\r\n  // ==== light theme text colors ====\r\n\r\n}\r\n","* {\r\n  padding: 0;\r\n  margin: 0;\r\n  box-sizing: border-box;\r\n  &::-webkit-scrollbar {\r\n    scrollbar-width: none;\r\n    display: none;\r\n    height: 0px;\r\n    width: 0px;\r\n  }\r\n}\r\n\r\nbody {\r\n  font-family: $font-family;\r\n}\r\n\r\nul {\r\n  padding: 0;\r\n  margin: 0;\r\n  list-style: none;\r\n}\r\n\r\nbutton {\r\n  &:focus-visible {\r\n    outline: none !important;\r\n  }\r\n}\r\n\r\n.desktop-order-track {\r\n  &.order-confirmed {\r\n    li {\r\n      &:first-child {\r\n        .rounded {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &.shipped {\r\n    li {\r\n      &:first-child {\r\n        &::before {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n        .rounded {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n      }\r\n      &:nth-child(2) {\r\n        &::after {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n        .rounded {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &.out-of-delivery {\r\n    li {\r\n      &:first-child {\r\n        &::before {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n        .rounded {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n      }\r\n      &:nth-child(2) {\r\n        &::after,\r\n        &::before {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n        .rounded {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n      }\r\n      &:nth-child(3) {\r\n        &::after {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n        .rounded {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &.delivery {\r\n    li {\r\n      &::after,\r\n      &::before {\r\n        background-color: theme(\"colors.yellowbuy\") !important;\r\n      }\r\n      .rounded {\r\n        background-color: theme(\"colors.yellowbuy\") !important;\r\n      }\r\n    }\r\n  }\r\n  .order-track {\r\n    z-index: 1;\r\n    &:last-child {\r\n      &::before {\r\n        display: none;\r\n      }\r\n    }\r\n    &:first-child {\r\n      &::after {\r\n        display: none;\r\n      }\r\n    }\r\n    &::before {\r\n      position: absolute;\r\n      content: \"\";\r\n      width: 50%;\r\n      height: 0.25rem;\r\n      right: 0;\r\n      top: 46%;\r\n      background-color: #e9e9e9;\r\n      z-index: -1;\r\n    }\r\n    &::after {\r\n      position: absolute;\r\n      content: \"\";\r\n      width: 50%;\r\n      height: 0.25rem;\r\n      left: 0;\r\n      top: 46%;\r\n      background-color: #e9e9e9;\r\n      z-index: -1;\r\n    }\r\n    .rounded {\r\n      background-color: #e9e9e9;\r\n    }\r\n  }\r\n}\r\n\r\n.mob-order-track-wrapper {\r\n  .mob-order-track {\r\n    z-index: 1;\r\n    &:last-child {\r\n      &::before {\r\n        display: none;\r\n      }\r\n    }\r\n    &::before {\r\n      position: absolute;\r\n      content: \"\";\r\n      height: 100%;\r\n      width: 0.25rem;\r\n      left: 0.7rem;\r\n      top: 0;\r\n      background-color: #e9e9e9;\r\n      z-index: -1;\r\n    }\r\n    .rounded {\r\n      background-color: #e9e9e9;\r\n    }\r\n  }\r\n  &.order-confirmed {\r\n    li {\r\n      &:first-child {\r\n        .rounded {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &.shipped {\r\n    li {\r\n      &:first-child {\r\n        .rounded {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n        &::before {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n      }\r\n      &:nth-child(2) {\r\n        .rounded {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &.out-of-delivery {\r\n    li {\r\n      &:first-child {\r\n        .rounded {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n        &::before {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n      }\r\n      &:nth-child(2) {\r\n        &::before {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n        .rounded {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n      }\r\n      &:nth-child(3) {\r\n        .rounded {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &.delivery {\r\n    li {\r\n      .rounded {\r\n        background-color: theme(\"colors.yellowbuy\") !important;\r\n      }\r\n      &::before {\r\n        background-color: theme(\"colors.yellowbuy\") !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.nft-track-container {\r\n  &.pending {\r\n    .nft-track-wrapper {\r\n      &:first-child {\r\n        .first-round {\r\n          background: #00000066 !important;\r\n          &::before {\r\n            background-color: #000000 !important;\r\n          }\r\n          .inner-round {\r\n            background-color: theme(\"colors.yellowbuy\") !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &.shipped {\r\n    .nft-track-wrapper {\r\n      &:first-child {\r\n        .first-round {\r\n          &::before {\r\n            background-color: #000000 !important;\r\n          }\r\n          .inner-round {\r\n            background-color: theme(\"colors.yellowbuy\") !important;\r\n          }\r\n        }\r\n      }\r\n      &:nth-child(2) {\r\n        .first-round {\r\n          background: #00000066 !important;\r\n          &::before {\r\n            background-color: #000000 !important;\r\n          }\r\n          .inner-round {\r\n            background-color: theme(\"colors.yellowbuy\") !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &.out_for_delivery {\r\n    .nft-track-wrapper {\r\n      &:first-child {\r\n        .first-round {\r\n          &::before {\r\n            background-color: #000000 !important;\r\n          }\r\n          .inner-round {\r\n            background-color: theme(\"colors.yellowbuy\") !important;\r\n          }\r\n        }\r\n      }\r\n      &:nth-child(2) {\r\n        .first-round {\r\n          &::before {\r\n            background-color: #000000 !important;\r\n          }\r\n          .inner-round {\r\n            background-color: theme(\"colors.yellowbuy\") !important;\r\n          }\r\n        }\r\n      }\r\n      &:nth-child(3) {\r\n        .first-round {\r\n          background: #00000066 !important;\r\n          &::before {\r\n            background-color: #000000 !important;\r\n          }\r\n          .inner-round {\r\n            background-color: theme(\"colors.yellowbuy\") !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  &.delivered {\r\n    .nft-track-wrapper {\r\n      .first-round {\r\n        &::before {\r\n          background-color: #000000 !important;\r\n        }\r\n        .inner-round {\r\n          background-color: theme(\"colors.yellowbuy\") !important;\r\n        }\r\n      }\r\n      &:last-child {\r\n        .first-round {\r\n          background: #00000066 !important;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n.nft-track-wrapper {\r\n  position: relative;\r\n  z-index: 1;\r\n  padding-bottom: 1.5rem;\r\n\r\n  &:first-child {\r\n    &::after {\r\n      position: absolute;\r\n      content: \"\";\r\n      height: 2.25rem;\r\n      width: 0.094rem;\r\n      left: 0.95rem;\r\n      top: -2rem;\r\n      border-left: 0.094rem dashed rgba(0, 0, 0, 0.4);\r\n      z-index: -1;\r\n    }\r\n  }\r\n  &:last-child {\r\n    padding-bottom: 0;\r\n    &::before {\r\n      display: none;\r\n    }\r\n  }\r\n  &::before {\r\n    position: absolute;\r\n    content: \"\";\r\n    height: calc(100% - 1.5rem);\r\n    width: 0.094rem;\r\n    left: 0.95rem;\r\n    top: 1.75rem;\r\n    border-left: 0.094rem dashed rgba(0, 0, 0, 0.4);\r\n    z-index: -1;\r\n  }\r\n\r\n  .first-round {\r\n    width: 2rem;\r\n    height: 2rem;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-radius: 50%;\r\n    position: relative;\r\n    &::before {\r\n      position: absolute;\r\n      content: \"\";\r\n      inset: 0;\r\n      width: 1.25rem;\r\n      height: 1.25rem;\r\n      margin: auto;\r\n      background-color: #00000066;\r\n      border-radius: 50%;\r\n    }\r\n    .inner-round {\r\n      width: 0.5rem;\r\n      height: 0.5rem;\r\n      background-color: theme(\"colors.yellowbuy\") 80;\r\n      border-radius: 50%;\r\n      position: relative;\r\n      z-index: 2;\r\n    }\r\n  }\r\n}\r\n\r\n.title-stroke {\r\n  background: #000000;\r\n  -webkit-background-clip: text;\r\n  -webkit-text-stroke-color: transparent;\r\n  -webkit-text-stroke-width: 0.125rem;\r\n  color: theme(\"colors.yellowbuy\");\r\n  font-weight: 800;\r\n  letter-spacing: 0.063rem;\r\n}\r\n\r\n.react-tel-input .form-control {\r\n  width: 100% !important;\r\n  @apply rounded-xl border-medium border-[#C2C2C2] hover:border-[#C2C2C2] focus:border-[#C2C2C2] h-11;\r\n  &:focus {\r\n    box-shadow: none !important;\r\n    border-color: #c2c2c2 !important;\r\n  }\r\n}\r\n\r\n.auth-section-bg {\r\n  background: url(\"../../images/auth-bg.webp\");\r\n  background-repeat: no-repeat;\r\n  background-size: cover;\r\n  background-position: center;\r\n}\r\n","// ==================================\r\n// ===  Linear Gradient Variable  ===\r\n// ==================================\r\n\r\n$gradients: ();\r\n// key : linear gradient color\r\n\r\n// Gradient Classes\r\n\r\n@each $gradient, $value in $gradients {\r\n  @include bg-gradient(\".bg-gradient-#{$gradient}\", $value);\r\n}\r\n\r\n$count: 5;\r\n$width_unit: \"%\";\r\n\r\n@while $count < 100 {\r\n  .width-#{$count} {\r\n    width: #{$count}#{$width_unit} !important;\r\n  }\r\n\r\n  $count: $count + 5;\r\n}\r\n\r\n\r\n$cursor : (\r\n  pointer : pointer,\r\n  none : none,\r\n);\r\n\r\n@each $name, $value in $cursor {\r\n  @include cursor(\".cursor-#{$name}\", $value);\r\n}\r\n","// ============== Standard Bootstrap Mixins ===================\r\n// ============================================================\r\n\r\n// min width mixins\r\n\r\n@mixin media-min-sm {\r\n  @media (min-width: #{$screen-sm}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin media-min-md {\r\n  @media (min-width: #{$screen-md}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin media-min-lg {\r\n  @media (min-width: #{$screen-lg}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin media-min-xl {\r\n  @media (min-width: #{$screen-xl}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin media-min-xxl {\r\n  @media (min-width: #{$screen-xxl}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n// max width mixins\r\n\r\n@mixin media-max-sm {\r\n  @media (max-width: #{$screen-sm}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin media-max-md {\r\n  @media (max-width: #{$screen-md}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin media-max-lg {\r\n  @media (max-width: #{$screen-lg}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin media-max-xl {\r\n  @media (max-width: #{$screen-xl}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin media-max-xxl {\r\n  @media (max-width: #{$screen-xxl}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n// min to max width mixins\r\n\r\n@mixin media-min-sm-max-md {\r\n  @media (min-width: #{$screen-sm}) and (max-width: #{$screen-md}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin media-min-md-max-lg {\r\n  @media (min-width: #{$screen-md}) and (max-width: #{$screen-lg}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin media-min-lg-max-xl {\r\n  @media (min-width: #{$screen-lg}) and (max-width: #{$screen-xl}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin media-min-xl-max-xxl {\r\n  @media (min-width: #{$screen-xl}) and (max-width: #{$screen-xxl}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n// ===================== Custom Mixins ========================\r\n// ============================================================\r\n\r\n// Custom min width mixins\r\n\r\n@mixin media-min-alt363 {\r\n  // ====  Example for min ====\r\n  @media (min-width : #{$screen-alt-363}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin media-min-alt($px) {\r\n  @media (min-width : #{$px}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n// Custom max width mixins\r\n\r\n@mixin media-max-alt363 {\r\n  // ====  Example for max ====\r\n  @media (max-width : #{$screen-alt-363}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin media-max-alt($px) {\r\n  @media (max-width : #{$px}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n// custom min to max mixins\r\n\r\n@mixin media-min-max-alt($min, $max) {\r\n  @media (min-width: #{$min}) and (max-width: #{$max}) {\r\n    @content;\r\n  }\r\n}\r\n\r\n// =======================\r\n// Linear Gradient Mixins\r\n// =======================\r\n\r\n// Gradient backgrounds\r\n\r\n@mixin bg-gradient($parent, $gradient) {\r\n  #{$parent} {\r\n    background: $gradient;\r\n  }\r\n}\r\n\r\n// cursor\r\n\r\n@mixin cursor($name,$value) {\r\n  #{$name} {\r\n    cursor: $value;\r\n  }\r\n}\r\n\r\n@mixin lineBreak($line,$showoverflow : \"ellipsis\") {\r\n  overflow: hidden;\r\n  text-overflow: $showoverflow;\r\n  display: -webkit-box !important;\r\n  -webkit-line-clamp: $line;\r\n  -webkit-box-orient: vertical;\r\n}\r\n\r\n@mixin scroll-bar($width:0.2rem,$height:0.2rem) {\r\n  scrollbar-width: thin;\r\n  &::-webkit-scrollbar {\r\n    width: $width;\r\n    height: $height;\r\n  }\r\n\r\n  &::-webkit-scrollbar-track {\r\n      // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);\r\n      // box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n      background-color: #707070;\r\n      outline: 0.05rem solid #707070;\r\n      border-radius: 50rem;\r\n  }\r\n}\r\n",".hero-section {\n  padding-top: 4rem;\n  background-color: #000;\n  @media screen and (max-width: 768px) {\n    padding-top: 3rem;\n  }\n  @media screen and (max-width: 568px) {\n    padding-top: 2rem;\n  }\n  .hero-container {\n    display: flex;\n    @media screen and (max-width: 991px) {\n      flex-direction: column;\n    }\n    .left-sdie-wrapper {\n      width: 60%;\n      padding: 0 5.5rem 0 4.25rem;\n      @media screen and (max-width: 991px) {\n        width: 100%;\n        padding: 1rem;\n      }\n      .content {\n        h1 {\n          margin: 0;\n          font-weight: 700;\n          font-size: 4.063rem;\n          line-height: 1.3;\n          text-transform: uppercase;\n          color: #fff;\n          span {\n            letter-spacing: 0.203rem;\n          }\n          @media screen and (max-width: 1400px) {\n            font-size: 3.5rem;\n          }\n          @media screen and (max-width: 1300px) {\n            font-size: 3rem;\n          }\n          @media screen and (max-width: 1300px) {\n            font-size: 3rem;\n          }\n          @media screen and (max-width: 1150px) {\n            font-size: 2.75rem;\n          }\n          @media screen and (max-width: 1100px) {\n            font-size: 2rem;\n          }\n          @media screen and (max-width: 991px) {\n            font-size: 4rem;\n          }\n          @media screen and (max-width: 768px) {\n            font-size: 3.5rem;\n          }\n          @media screen and (max-width: 600px) {\n            font-size: 3rem;\n            span {\n              letter-spacing: 0.125rem;\n            }\n          }\n          @media screen and (max-width: 567px) {\n            font-size: 2.75rem;\n          }\n          @media screen and (max-width: 480px) {\n            font-size: 2rem;\n          }\n          @media screen and (max-width: 360px) {\n            font-size: 1.5rem;\n          }\n        }\n        h6 {\n          margin: 0;\n          font-weight: 700;\n          font-size: 7.5rem;\n          line-height: 1.2;\n          color: #00ff7f;\n          @media screen and (max-width: 1300px) {\n            font-size: 6rem;\n          }\n          @media screen and (max-width: 1200px) {\n            font-size: 5rem;\n          }\n          @media screen and (max-width: 360px) {\n            font-size: 4rem;\n          }\n        }\n        p {\n          margin: 0;\n          font-weight: 400;\n          font-size: 1.25rem;\n          line-height: 1.6;\n          color: #fff;\n          max-width: 27rem;\n          @media screen and (max-width: 1100px) {\n            max-width: 25rem;\n          }\n          @media screen and (max-width: 991px) {\n            max-width: unset;\n          }\n          @media screen and (max-width: 567px) {\n            font-size: 1rem;\n          }\n        }\n      }\n    }\n    .right-sdie-wrapper {\n      position: relative;\n      width: 40%;\n      background: #00ff7f;\n      z-index: 1;\n      @media screen and (max-width: 991px) {\n        width: 100%;\n        padding: 2rem 1rem;\n      }\n      &::after {\n        position: absolute;\n        content: \"\";\n        right: 0;\n        bottom: 0;\n        clip-path: polygon(100% 30%, 0% 100%, 100% 100%);\n        width: 10rem;\n        height: 10rem;\n        background-color: #000;\n        z-index: -1;\n        @media screen and (max-width: 991px) {\n          display: none;\n        }\n      }\n\n      img {\n        position: relative;\n        top: -3rem;\n        left: -6rem;\n        @media screen and (max-width: 1500px) {\n          left: -4rem;\n        }\n        @media screen and (max-width: 1400px) {\n          left: -3.5rem;\n        }\n        @media screen and (max-width: 991px) {\n          position: unset;\n          top: 0;\n          left: 0;\n        }\n      }\n      button {\n        position: absolute;\n        right: 21%;\n        bottom: -1rem;\n        @media screen and (min-width: 360px) {\n          right: 27%;\n          bottom: -1rem;\n        }\n        @media screen and (min-width: 992px) {\n          right: 38%;\n          bottom: 2rem;\n        }\n      }\n    }\n  }\n}\n",".shoe-banner-section {\n  overflow: hidden;\n\n  .shoe-banner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    @media screen and (max-width:1300px) {\n      min-height: 25rem;\n    }\n    @media screen and (max-width:992px) {\n      min-height: 20rem;\n    }\n    @media screen and (max-width:768px) {\n      min-height: 15rem;\n    }\n    @media screen and (max-width:568px) {\n      min-height: 8rem;\n    }\n    .shoe-image {\n      position: absolute;\n      inset: 0;\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n      transform: scale(1.8);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
